import { Link, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

interface Props {
  content: string;
}

export const StyledMarkdown = (props: Props) => {
  const { content } = props;
  return (
    <ReactMarkdown
      linkTarget="_blank"
      components={{
        h1: ({ children }) => (
          <Typography variant="h1" color="white">
            {children}
          </Typography>
        ),
        h2: ({ children }) => (
          <Typography variant="h2" color="white">
            {children}
          </Typography>
        ),
        h3: ({ children }) => (
          <Typography variant="h3" color="white">
            {children}
          </Typography>
        ),
        h4: ({ children }) => (
          <Typography variant="h4" color="white">
            {children}
          </Typography>
        ),
        h5: ({ children }) => (
          <Typography variant="h5" color="white">
            {children}
          </Typography>
        ),
        h6: ({ children }) => (
          <Typography variant="h6" color="white">
            {children}
          </Typography>
        ),
        p: ({ children }) => (
          <Typography variant="body1" color="white">
            {children}
          </Typography>
        ),
        a: ({ href, children }) => (
          <Link href={href} rel="norefferer noopener" target="_blank">
            {children}
          </Link>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};
